var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { TypeActionPendingInventoryInfo, } from "./actionPendingInventoryInfo";
var initial = {
    pending: [],
};
export var reducerPendingInventoryInfo = function (state, action) {
    if (state === void 0) { state = initial; }
    if (action.type === TypeActionPendingInventoryInfo.Received) {
        return __assign({}, state, action.pendingInventoryInfo);
    }
    return state;
};



//////////////////
// WEBPACK FOOTER
// ./src/features/pending-inventory/reducerPendingInventory.ts
// module id = 2967
// module chunks = 3